module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Are you sure you want to cancel this appointment?\n      "), _c('v-spacer'), _vm._v(" "), (_vm.appointmentRequest.loading) ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "size": "20",
      "width": "2",
      "indeterminate": "",
      "color": "amber"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', {
    staticClass: "elevation-4 mb-4 pa-0",
    attrs: {
      "subheader": "",
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("Appointment details:")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.appointment
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "disabled": !_vm.hasContacts,
      "hint": _vm.sendCommsHint,
      "persistent-hint": !_vm.hasContacts,
      "label": "Send a message to the customer?",
      "light": ""
    },
    model: {
      value: (_vm.withCommunication),
      callback: function($$v) {
        _vm.withCommunication = $$v
      },
      expression: "withCommunication"
    }
  }), _vm._v(" "), (_vm.appointmentDetail && _vm.appointmentDetail.contact_phone) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "outline": "",
      "color": "success",
      "href": _vm.whatsappIt(_vm.appointmentDetail.contact_phone, _vm.cancelMessage),
      "target": "_blank"
    }
  }, [_vm._v("\n          WhatsApp\n          "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.withCommunication) ? [_c('small', {
    staticClass: "overline"
  }, [_vm._v("Contact details:")]), _vm._v(" "), (_vm.appointmentDetail.contact_phone) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.appointmentDetail.contact_phone))]) : _vm._e(), _vm._v(" "), (_vm.appointmentDetail.contact_phone) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.appointmentDetail.contact_email))]) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "label": "Include link to book a new appointment",
      "hint": "Will include a link to your booking widget so that they can schedule a new appointment",
      "light": ""
    },
    model: {
      value: (_vm.withBookingLink),
      callback: function($$v) {
        _vm.withBookingLink = $$v
      },
      expression: "withBookingLink"
    }
  })] : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm9": "",
      "md10": "",
      "lg11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": _vm.clearpriceIcon,
      "prefix": _vm.appointment.currency,
      "type": "number",
      "label": "Clear codes and set new price"
    },
    on: {
      "click:prepend": _vm.toggleClearPrice
    },
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": "",
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "disabled": !_vm.clearprice,
      "small": "",
      "outline": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.price = 0
      }
    }
  }, [_vm._v("Set Zero")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "prepend-icon": _vm.withInvoiceDescriptionIcon,
      "readonly": !_vm.withInvoiceDescription,
      "hint": "You can add an invoice description - something like: \"late cancellation\"",
      "label": "Set invoice description"
    },
    on: {
      "click:prepend": _vm.toggleInvoiceDescription
    },
    model: {
      value: (_vm.invoiceDescription),
      callback: function($$v) {
        _vm.invoiceDescription = $$v
      },
      expression: "invoiceDescription"
    }
  }), _vm._v(" "), (_vm.withInvoiceDescription) ? [_c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Quick picks")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.invoiceDescription = "Appointment cancelled"
      }
    }
  }, [_vm._v("Appointment cancelled")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.invoiceDescription = "Late cancellation"
      }
    }
  }, [_vm._v("Late cancellation")])] : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.response.loading,
      "disabled": !_vm.appointment.id
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Cancel Appointment\n      ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94998c00","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/Cancel.vue
// module id = 1499
// module chunks = 9